import { render, staticRenderFns } from "./packaging_locations.vue?vue&type=template&id=22e733dc&"
import script from "./packaging_locations.vue?vue&type=script&lang=js&"
export * from "./packaging_locations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports